import React from "react";
import awardIcon from "assets/icons/award.svg";
import { useTranslation } from "react-i18next";

function AboutUsPageBanner() {
	const { t } = useTranslation();

	return (
		<div className="container">
			<div className="mt-20 lg:mt-10 text-white text-center bg-gradient-to-br from-blue-900 via-blue-700 to-sky-400 rounded-3xl flex flex-col items-center gap-10 p-7 sm:p-14 relative">
				<img
					src={ awardIcon }
					alt="AWARD_ICON"
					className="absolute top-[-25%] right-[50px] w-[75px] lg:w-[150px] hidden sm:block"
				/>
				<div className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-medium">
					{ t(`aboutUsPage.banner.title`) }
				</div>
				<div className="text-base lg:text-xl font-light">
					{ t(`aboutUsPage.banner.text`) }
				</div>
			</div>
		</div>
	);
}

export default AboutUsPageBanner;